import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { t } from '@/i18n';
import type { FiscalInvoiceStatus, FiscalReceiptStatus } from '@ip/shared-types';

// Shared color scale — same semantics across invoices/receipts, only the
// i18n labels differ (feminine "faktura" vs masculine "paragon" agreement,
// see fiscal.invoiceStatus / fiscal.receiptStatus).
const STATUS_CLASSES: Record<string, string> = {
  QUEUED: 'border-gray-500/40 bg-gray-500/10 text-gray-700 dark:text-gray-400',
  PROCESSING: 'border-blue-500/40 bg-blue-500/10 text-blue-700 dark:text-blue-400',
  RETRY_WAIT: 'border-amber-500/40 bg-amber-500/10 text-amber-700 dark:text-amber-400',
  DISPATCHED: 'border-blue-500/40 bg-blue-500/10 text-blue-700 dark:text-blue-400',
  CONFIRMED: 'border-emerald-500/40 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400',
  REJECTED: 'border-red-500/40 bg-red-500/10 text-red-700 dark:text-red-400',
};

export function FiscalInvoiceStatusBadge({ status }: { status: FiscalInvoiceStatus }) {
  return (
    <Badge variant="outline" className={cn('font-normal', STATUS_CLASSES[status])}>
      {t(`fiscal.invoiceStatus.${status}`)}
    </Badge>
  );
}

export function FiscalReceiptStatusBadge({ status }: { status: FiscalReceiptStatus }) {
  return (
    <Badge variant="outline" className={cn('font-normal', STATUS_CLASSES[status])}>
      {t(`fiscal.receiptStatus.${status}`)}
    </Badge>
  );
}
